import React from 'react';

export const PermissaoContexto = React.createContext(null);